import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

// Add session token from localStorage to every request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('session_token')) {
      localStorage.removeItem('session_token');
      if (!error.config?.url?.endsWith('/auth/me') && window.location.pathname !== '/login') window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
